<header class="header" [dir]="lang.getDir()">
  <div class="container header-container">
    <!-- Logo -->
    <div class="logo">
      <img [src]="logo" alt="Logo" />
      <span>{{ 'site.name' | translate }}</span>
    </div>

    <!-- Optional: Language Switcher, Menu, etc. -->
  </div>
</header>
